/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Space,
  Stack,
  Text,
} from '@tonic-one/react';
import { useToggle } from '@tonic-one/react-hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import lngs from 'src/mapping/lngs.json';
import Hide from '../../../Common/Hide';
import { reportPendo } from '../../../../utils/setupPendo';

const LanguageSetting = (props: any) => {
  const [isOpen, toggleModal] = useToggle(false);
  const { t, i18n } = useTranslation();
  const languageSetting_t = i18n.getFixedT(
    null,
    'header',
    'header.languageSetting.list'
  );
  const [lang, setLang] = useState<string>('en');
  useEffect(() => {
    const lng = localStorage.getItem('i18nextLng') || 'en';
    setLang(lng);
    if (props.languageSettingShow) {
      toggleModal(true);
    } else {
      toggleModal(false);
    }
  }, [props.languageSettingShow]);

  const save = async () => {
    // await i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    reportPendo('CasHeader.AccountSetting.LanguageSetting.Save.Click', {
      language: lang,
    });
    // props.closeLanguageSetting();
    window.location.reload();
  };

  const onChange = (value: string) => {
    setLang(value);
  };

  function RadioItem(props: any) {
    const radio = props.lng;
    return (
      <>
        <Radio value={radio.key} pt="5px">
          {languageSetting_t(radio.value)}
        </Radio>
        <Hide state={radio.desc}>
          <br />
          <Text ml="25px">{radio.desc}</Text>
        </Hide>
      </>
    );
  }
  return (
    <Modal
      ensureFocus
      autoFocus
      closeOnEsc
      closeOnOutsideClick
      isClosable
      isOpen={isOpen}
      onClose={props.closeLanguageSetting}
    >
      <ModalOverlay />
      <ModalContent width={372} mr={0} height="100%">
        <ModalHeader pr="10px">
          {t('header.account.languageSetting')}
        </ModalHeader>
        <ModalBody>
          <RadioGroup value={lang} onChange={onChange}>
            <Stack spacing="1x" shouldWrapChildren>
              {lngs.lngs.map((lng, i) => (
                <RadioItem lng={lng} key={i}></RadioItem>
              ))}
            </Stack>
          </RadioGroup>
        </ModalBody>
        <ModalFooter display="inline-block" borderTop="0px">
          <Button
            data-track={`CasHeader.AccountSetting.LanguageSetting.save`}
            variant="primary"
            minWidth="20x"
            onClick={save}
          >
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={props.closeLanguageSetting}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LanguageSetting;
